<template>
  <div class="variation-tags-wrapper d-flex flex-wrap pt-md-3 pl-md-3 mt-3">
    <span
      v-for="({selection, value}) in variationTags"
      :key="selection.propertyId"
    >
      <span
        class="badge"
        :style="{color: selection.color, backgroundColor: selection.bgcolor}"
      >
        {{ selection.texts[lang].replace('$1', value.values.value) }}
      </span>

    </span>
  </div>
</template>

<script>
import normalizeVariationProperties from '../../mixins/property-normalizer'
export default {
    name: 'MhVariationTags',
    mixins: [normalizeVariationProperties],
    props: {
        variationProperties: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        validTags () {
            return App.modeherzConfig.variationTags.reduce((agg, cur) => ({ [cur.propertyId]: cur, ...agg }), {})
        },
        lang () {
            return App.language
        },
        variationTags () {
            if (!this.variationProperties) {
                return []
            }
            return this.normalizeVariationProperties(this.variationProperties, { selection: this.validTags, sortByPriority: true })
        }
    }
}
</script>
